export function eventSlider() {
    $(".event-slider").slick({
        fade: true,
        arrows: true,
        prevArrow: "<div class='sl-btn sl-btn--prev'><svg viewBox='0 0 31 12' xmlns='http://www.w3.org/2000/svg'><path d='m0 6 10 5.774V.226L0 6Zm30 1a1 1 0 1 0 0-2v2ZM9 7h21V5H9v2Z'/></svg></div>",
        nextArrow: "<div class='sl-btn sl-btn--next'><svg viewBox='0 0 31 12' xmlns='http://www.w3.org/2000/svg'><path d='M1 5a1 1 0 0 0 0 2V5Zm30 1L21 .226v11.547L31 6ZM1 7h21V5H1v2Z'/></svg></div>",
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/event-slider.js